const binding = { modules: {}, dataActions: {} };

    const registerActionId = (actionPath) => {
        if (binding.dataActions[actionPath] &&
            binding.dataActions[actionPath].default &&
            binding.dataActions[actionPath].default.prototype &&
            binding.dataActions[actionPath].default.prototype.id) {
            binding.dataActions[binding.dataActions[actionPath].default.prototype.id] = binding.dataActions[actionPath];
        } else {
            Object.keys(binding.dataActions[actionPath] || {}).forEach(exportName => {
                if (binding.dataActions[actionPath][exportName] &&
                    binding.dataActions[actionPath][exportName].prototype &&
                    binding.dataActions[actionPath][exportName].prototype.Action) {
                    binding.dataActions[binding.dataActions[actionPath][exportName].prototype.id] = binding.dataActions[actionPath][exportName];
                }
            })
        }
    };

    const registerSanitizedActionPath = (sanitizedActionPath, dataAction) => {
        if (process.env.NODE_ENV === 'development') {
            if (!dataAction.default) {
                throw new Error('Data action path does not have a default export');
            }
            if (!(dataAction.default.prototype.id && binding.dataActions[dataAction.default.prototype.id]) || !binding.dataActions[sanitizedActionPath]) {
                binding.dataActions[sanitizedActionPath] = dataAction;
            }
        } else {
            binding.dataActions[sanitizedActionPath] = dataAction;
            if (!binding.dataActions[sanitizedActionPath].default) {
                throw new Error('Data action path ' + sanitizedActionPath + ' does not have a default export');
            }
            binding.dataActions[sanitizedActionPath].default.prototype.RegistrationId = sanitizedActionPath;
            if (binding.dataActions[sanitizedActionPath].default.prototype.id) {
                binding.dataActions[binding.dataActions[sanitizedActionPath].default.prototype.id] = sanitizedActionPath;
            }
        }
    };
    

        {   
            const actionPath = 'actions/customProxy/orderHistory/add-product-to-existing-sales-order.action';
            binding.dataActions[actionPath] = require('partner/actions/customProxy/orderHistory/add-product-to-existing-sales-order.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/customProxy/orderHistory/cancel-sales-order.action';
            binding.dataActions[actionPath] = require('partner/actions/customProxy/orderHistory/cancel-sales-order.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/customProxy/orderHistory/get-sales-order-details-by-sales-id.action';
            binding.dataActions[actionPath] = require('partner/actions/customProxy/orderHistory/get-sales-order-details-by-sales-id.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/customProxy/priceList/get-price-list-by-customer.action';
            binding.dataActions[actionPath] = require('partner/actions/customProxy/priceList/get-price-list-by-customer.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-categories-hierarchy-safe.action';
            binding.dataActions[actionPath] = require('partner/actions/get-categories-hierarchy-safe.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-current-category-hierarchy-safe.action';
            binding.dataActions[actionPath] = require('partner/actions/get-current-category-hierarchy-safe.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-attributes.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-attributes.action');
            registerActionId(actionPath);
        }

        {   
            const actionPath = 'actions/get-product-units-of-measure.action';
            binding.dataActions[actionPath] = require('partner/actions/get-product-units-of-measure.action');
            registerActionId(actionPath);
        }

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.packageDataActions = {};
        window.__bindings__.packageDataActions['__local__'] = {
            ...binding.dataActions
        };